module.exports = __webpack_public_path__ + "img/logo_dsv.fc699bd7.png";